/**
 * Function to apply escape string regexp to the given string
 *
 * @param {string} string
 *
 * @returns {string}
 */
export var escapeStringRegexp = function (string) {
    if (typeof string !== 'string') {
        throw new TypeError('Expected a string');
    }
    return string
        .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
        .replace(/-/g, '\\x2d');
};
//# sourceMappingURL=escapeStringRegexp.js.map